import { apiClient } from './index';

export interface PreseedProduct {
  mpn?: string;
  manufacturer?: string;
  upc?: string;
  sku?: string;
  ingram_sku?: string;
  product_id?: string;
}

export interface PreseedJobSummary {
  job_id: number;
  client_name: string;
  status: string;
  total: number;
  completed: number;
  failed: number;
  progress: number;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
}

export interface PreseedResultItem {
  identifiers: Record<string, string>;
  status: string;
  product?: Record<string, unknown>;
  error?: string;
}

export async function submitPreseed(products: PreseedProduct[]): Promise<{ job_id: number; total: number; status: string }> {
  const { data } = await apiClient.post('/api/v1/preseed', { products });
  return data;
}

export async function getPreseedStatus(jobId: number): Promise<PreseedJobSummary> {
  const { data } = await apiClient.get(`/api/v1/preseed/status/${jobId}`);
  return data;
}

export async function getPreseedResults(jobId: number): Promise<{ job_id: number; items: PreseedResultItem[] }> {
  const { data } = await apiClient.get(`/api/v1/preseed/${jobId}/results`);
  return data;
}

export async function cancelPreseedJob(jobId: number): Promise<void> {
  await apiClient.post(`/api/v1/preseed/${jobId}/cancel`);
}

export async function listPreseedJobs(limit: number = 20): Promise<PreseedJobSummary[]> {
  const { data } = await apiClient.get('/api/v1/preseed/jobs', { params: { limit } });
  return data;
}
